import { render, staticRenderFns } from "./SimilarJobsPreview.vue?vue&type=template&id=b8f2d2f2&"
import script from "./SimilarJobsPreview.vue?vue&type=script&lang=js&"
export * from "./SimilarJobsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports